import { apiAxioma } from 'src/enviroment/apileadsAxioma'
import axios from 'axios'
import { loaderService } from 'src/services/loaderService'

const getToken = () =>
  JSON.parse(sessionStorage.getItem('userInfo')).token || null

// WebSocket Service para Básculas
const WS_BASE_URL = 'wss://axion-server-305461449210.us-central1.run.app/ws'

export class BasculaWebSocketService {
  constructor() {
    this.socket = null
    this.roomId = null
    this.isManuallyClosed = false
    this.reconnectTimeout = null
    this.onMessageCallback = null
    this.onStatusChangeCallback = null
  }

  connect(roomId, onMessage, onStatusChange) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('Socket ya está conectado')
      return
    }

    this.roomId = roomId
    this.onMessageCallback = onMessage
    this.onStatusChangeCallback = onStatusChange
    this.isManuallyClosed = false

    const token = getToken()
    if (!token) {
      console.error('No hay token disponible para la conexión WebSocket')
      return
    }

    const wsUrl = `${WS_BASE_URL}/?user_type=front&user_id=front1&room_id=${roomId}&auth=${token}`
    console.log('Conectando a WebSocket:', wsUrl.replace(token, 'TOKEN_HIDDEN'))

    this.socket = new WebSocket(wsUrl)

    this.socket.onopen = () => {
      console.log('✅ Conectado al WebSocket de báscula')
      if (this.onStatusChangeCallback) {
        this.onStatusChangeCallback(true)
      }
    }

    this.socket.onclose = () => {
      console.log('❌ Desconectado del WebSocket de báscula')
      if (this.onStatusChangeCallback) {
        this.onStatusChangeCallback(false)
      }

      // Reconexión automática solo si no fue cerrado manualmente
      if (!this.isManuallyClosed && this.roomId) {
        console.log('Reintentando conexión en 5 segundos...')
        this.reconnectTimeout = setTimeout(() => {
          this.connect(
            this.roomId,
            this.onMessageCallback,
            this.onStatusChangeCallback,
          )
        }, 5000)
      }
    }

    this.socket.onerror = (error) => {
      console.error('❌ Error en WebSocket:', error)
    }

    this.socket.onmessage = (event) => {
      console.log('📨 Mensaje recibido del WebSocket:', event.data)
      try {
        const message = JSON.parse(event.data)
        console.log('📦 Mensaje parseado:', message)
        if (this.onMessageCallback) {
          this.onMessageCallback(message)
        }
      } catch (e) {
        console.error('Error al parsear mensaje JSON:', e)
        console.log('Mensaje raw:', event.data)
      }
    }
  }

  disconnect() {
    this.isManuallyClosed = true
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout)
      this.reconnectTimeout = null
    }
    if (this.socket) {
      this.socket.close()
      this.socket = null
    }
    this.roomId = null
    console.log('🔌 Conexión WebSocket cerrada manualmente')
  }

  isConnected() {
    return this.socket && this.socket.readyState === WebSocket.OPEN
  }

  sendMessage(message) {
    if (this.isConnected()) {
      this.socket.send(JSON.stringify(message))
      console.log('➡️ Mensaje enviado:', message)
    } else {
      console.warn('⚠️ No hay conexión activa para enviar mensaje')
    }
  }
}

// Instancia singleton del servicio
export const basculaWebSocketService = new BasculaWebSocketService()

export const getIam = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/usuarios/iam', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getIamRol = async (usuarioId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/usuarios/iam/rol?usuario_id=${usuarioId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      console.log('=== Respuesta del rol del usuario ===')
      console.log('Usuario ID:', usuarioId)
      console.log('Respuesta completa:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener rol del usuario:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getAuthenticate = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/usuarios', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getAllRepuestos = async () => {
  try {
    const response = await apiAxioma.get('/v1/repuestos/streaming', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getRepuestosPorEstado = async (estado) => {
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/por_estado?estado=${estado}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getPrioridades = async () => {
  try {
    const response = await apiAxioma.get('/v1/repuestos/prioridades', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200 && response.data) {
      const data = response.data?.success ?? response.data
      const prioridades = Array.isArray(data) ? data : []
      return prioridades.map((p) =>
        typeof p === 'string' ? { prioridad: p } : p,
      )
    }
    return []
  } catch (error) {
    console.error('Error al obtener prioridades:', error)
    return []
  }
}

export const getRepuestosPaginados = async ({
  estado,
  marca,
  categoriaAx,
  material,
  prioridad,
  pagina = 1,
} = {}) => {
  loaderService.show()
  try {
    const queryParams = new URLSearchParams({
      pagina: pagina.toString(),
    })

    if (estado) {
      queryParams.append('estado', estado)
    }

    if (marca) {
      queryParams.append('marca', marca)
    }

    if (categoriaAx) {
      queryParams.append('categoria_ax', categoriaAx)
    }

    if (material) {
      queryParams.append('material', material)
    }

    if (prioridad) {
      queryParams.append('prioridad', prioridad)
    }

    const response = await apiAxioma.get(
      `/v1/repuestos?${queryParams.toString()}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getNotificacionesCambios = async ({
  codigoMaterial,
  estado,
  urgente,
  variable,
  vertical,
  prioridad,
} = {}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/notificacion_cambios/obtener',
      {
        codigo_material: codigoMaterial || null,
        estado: estado || null,
        urgente: urgente || null,
        variable: variable || null,
        vertical: vertical || null,
        prioridad: prioridad || null,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putNotificacionEnProceso = async (notificacionId, enProceso) => {
  try {
    const response = await apiAxioma.put(
      `/v1/notificacion_cambios/en_proceso?notificacion_id=${notificacionId}`,
      { en_proceso: enProceso ? 1 : 0 },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al actualizar en_proceso:', error)
    throw error
  }
}

export const putRevisionActualizacionCatalogoCorregido = async (
  revisionId,
  actualizacionCatalogoCorregido,
) => {
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/actualizacion_catalogo_corregido',
      {
        revision_id: revisionId,
        actualizacion_catalogo_corregido: actualizacionCatalogoCorregido
          ? 1
          : 0,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error(
      'Error al actualizar actualizacion_catalogo_corregido:',
      error,
    )
    throw error
  }
}

export const getRepuestosPorCodigoSap = async (codigoSap) => {
  loaderService.show()
  codigoSap = codigoSap.replace(/ /g, ',')
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/por_codigo?codigo_sap=${codigoSap}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getRepuestosPorNpf = async (npf) => {
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/por_npf?npf=${encodeURIComponent(String(npf).trim())}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
  }
}

export const getRepuestosExportable = async (estado) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/exportable?estado=${estado || 'TODOS'}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      console.log('response', response.data)
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// revisiones - opciones de descripción para plantilla de medidas
export const getPlantillaMedidasOpciones = async (
  categoriaId,
  subcategoriaId,
) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      categoria_id: categoriaId,
      subcategoria_id: subcategoriaId,
    })
    const response = await apiAxioma.get(
      `/v1/revisiones/plantilla_medidas/opciones?${params}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 && response.data) {
      return response.data
    }
    return null
  } catch (error) {
    return null
  } finally {
    loaderService.hide()
  }
}

// revisiones - plantilla de medidas por categoría/subcategoría (y opcionalmente definicion_cotas)
export const getPlantillaMedidas = async (
  categoriaId,
  subcategoriaId,
  definicionCotas,
) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      categoria_id: categoriaId,
      subcategoria_id: subcategoriaId,
    })
    if (definicionCotas) {
      params.append('descripcion', definicionCotas)
    }
    const response = await apiAxioma.get(
      `/v1/revisiones/plantilla_medidas?${params}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 && response.data) {
      return response.data
    }
    return null
  } catch (error) {
    return null
  } finally {
    loaderService.hide()
  }
}

/**
 * Sincroniza descripción correcta con HU de forma silenciosa (fire-and-forget).
 * Sin loader ni feedback al usuario; fallos se ignoran.
 */
export const postHuTexto = (codigo, descripcion) => {
  if (!codigo || !descripcion) return
  try {
    apiAxioma
      .post(
        '/v1/hu/texto',
        { codigo: String(codigo), descripcion },
        {
          headers: {
            Authorization: `${getToken()}`,
          },
        },
      )
      .catch(() => {})
  } catch (_) {
    // silencioso
  }
}

/**
 * Dispara postHuTexto solo si cambió la descripción correcta
 * y el material no está en PENDIENTE POR ASIGNAR.
 */
export const maybeSyncHuTextoTrasRevision = ({
  codigo,
  descripcionNueva,
  descripcionAnterior,
  estado,
} = {}) => {
  if (!codigo || !descripcionNueva) return
  if (estado === 'PENDIENTE POR ASIGNAR') return
  const anterior = String(descripcionAnterior ?? '').trim()
  const nueva = String(descripcionNueva ?? '').trim()
  if (!nueva || anterior === nueva) return
  postHuTexto(codigo, nueva)
}

// revisiones
export const putUpdateRevision = async (data, huTextoContext) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put('/v1/revisiones', data, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      if (huTextoContext) {
        maybeSyncHuTextoTrasRevision(huTextoContext)
      }
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putRelacionHomologo = async ({
  revisionId,
  homologoId,
  origen,
}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/homologo',
      {
        revision_id: revisionId,
        homologo_sugerido_id: homologoId,
        ...(origen ? { origen } : {}),
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putRelacionReemplazante = async ({
  revisionId,
  reemplazanteId,
  origen,
}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/reemplazante',
      {
        revision_id: revisionId,
        reemplazante_sugerido_id: reemplazanteId,
        ...(origen ? { origen } : {}),
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putRelacionModelo = async ({
  revisionId,
  modeloId,
  esPrincipal,
  silent = false,
}) => {
  if (!silent) loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/modelo_aplicacion',
      {
        revision_id: revisionId,
        modelo_aplicacion_id: modeloId,
        es_principal: esPrincipal,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return {
      success: false,
      error: 'No se pudo vincular el modelo',
    }
  } catch (error) {
    const mensaje =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Error al vincular el modelo'
    return { success: false, error: mensaje }
  } finally {
    if (!silent) loaderService.hide()
  }
}

export const putDesvincularHomologo = async ({ revisionId, homologoId }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/homologo/desasociar',
      { revision_id: revisionId, homologo_sugerido_id: homologoId },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putDesvincularReemplazante = async ({
  revisionId,
  reemplazanteId,
}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/reemplazante/desasociar',
      { revision_id: revisionId, reemplazante_sugerido_id: reemplazanteId },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putDesvincularModelo = async ({
  revisionId,
  modeloId,
  esPrincipal,
}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/modelo_aplicacion/desasociar',
      {
        revision_id: revisionId,
        modelo_aplicacion_id: modeloId,
        es_principal: esPrincipal,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putAsignarMaterialRevision = async ({ repuestoId, usuarioId }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/revisiones',
      { repuesto_id: repuestoId, usuario_id: usuarioId },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putAsignarMaterialRevisionSTG = async ({
  repuestoId,
  usuarioId,
}) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/revisiones',
      { repuesto_id: repuestoId, usuario_id: usuarioId },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const putLiberarMaterial = async ({ repuestoId }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/liberar',
      { repuesto_id: repuestoId },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getReferenciasRepuesto = async (revisionId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/relaciones_sugerida?revision_id=${revisionId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getRelacionesSugeridasPorCodigo = async (codigo) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/repuestos/relaciones_sugerida_codigo?codigo=${codigo}`,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co/',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// export const getReferenciasRepuestoMaestra = async (repuestoOrigenId) => {
//   try {
//     const response = await apiAxioma.get(`/v1/repuestos/relaciones_maestra?repuesto_origen_id=${repuestoOrigenId}`, {
//       headers: {
//         Authorization: `${getToken()}`,
//       },
//     })
//     if (response.status === 200) {
//       return response.data
//     }
//     return false
//   } catch (error) {
//     return false
//   }
// }

export const getMarcas = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/marcas`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSubSegmentos = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/subsegmentos`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSegmentos = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/segmentos`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getCategorias = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/categorias`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSubCategorias = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/subcategorias`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// ==================== Cascada de jerarquía por sector ====================
// El backend filtra cada nivel por el nombre (no el id) de sus padres.

export const getCategoriasPorSector = async (sector) => {
  try {
    const response = await apiAxioma.get(`/v1/categorias/por_sector`, {
      params: { sector },
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSubCategoriasPorCategoria = async ({ sector, categoria }) => {
  try {
    const response = await apiAxioma.get(`/v1/subcategorias/por_categoria`, {
      params: { sector, categoria },
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSegmentosPorSubCategoria = async ({
  sector,
  categoria,
  subcategoria,
}) => {
  try {
    const response = await apiAxioma.get(`/v1/segmentos/por_subcategoria`, {
      params: { sector, categoria, subcategoria },
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSubSegmentosPorSegmento = async ({
  sector,
  categoria,
  subcategoria,
  segmento,
}) => {
  try {
    const response = await apiAxioma.get(`/v1/subsegmentos/por_segmento`, {
      params: { sector, categoria, subcategoria, segmento },
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const uploadReferenceImage = async (codigoMaterial, imageFile) => {
  loaderService.show()
  try {
    // Crear FormData para enviar el archivo
    const formData = new FormData()
    formData.append('imagen', imageFile)

    const response = await apiAxioma.post(
      `/v1/revisiones/subir_imagen?codigo_material=${codigoMaterial}`,
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      return response.data
    }
  } catch (error) {
    console.error('Error uploading reference image:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getImagesByMaterial = async (codigoMaterial) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/revisiones/imagenes?codigo_material=${codigoMaterial}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const uploadImagenEmpaque = async (codigoMaterial, imageFile) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('imagen', imageFile)
    formData.append('codigo_material', codigoMaterial)

    const response = await apiAxioma.post(
      '/v1/revisiones/subir_imagen_empaque',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error uploading imagen empaque:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getImagenesEmpaque = async (codigoMaterial) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/revisiones/imagenes_empaque?codigo_material=${codigoMaterial}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const deleteImagenEmpaque = async (codigoMaterial, pathImage) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      codigo_material: codigoMaterial,
      path: pathImage,
    })
    const response = await apiAxioma.delete(
      `/v1/revisiones/imagenes_empaque?${params}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// Imagen para cotización (fotos + cotas + tabla). Una sola por material:
// subir otra reemplaza la anterior.
export const uploadImagenCotizacion = async (codigoMaterial, imagen) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('imagen', imagen, `${codigoMaterial}_cotizacion.jpg`)
    formData.append('codigo_material', codigoMaterial)

    const response = await apiAxioma.post(
      '/v1/revisiones/imagen_cotas_revision',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error uploading imagen cotización:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getImagenCotizacion = async (codigoMaterial) => {
  try {
    const response = await apiAxioma.get(
      `/v1/revisiones/imagen_cotas_revision?codigo_material=${codigoMaterial}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const deleteImagenCotizacion = async (codigoMaterial) => {
  loaderService.show()
  try {
    const response = await apiAxioma.delete(
      `/v1/revisiones/imagen_cotas_revision?codigo_material=${codigoMaterial}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const deleteReferenceImage = async (pathImage) => {
  loaderService.show()
  try {
    const response = await apiAxioma.delete(
      `/v1/revisiones/imagenes?path=${pathImage}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postBuscarSimilaresReemplazantes = async (
  codigo,
  umbral = 0.8,
  mismaMarca = false,
) => {
  try {
    const response = await apiAxioma.post(
      '/v1/hu/similares',
      { codigo, umbral, misma_marca: mismaMarca },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error buscando similares reemplazantes:', error)
    return false
  }
}

export const postRepuestosPorCodigos = async (codigos) => {
  try {
    const response = await apiAxioma.post(
      '/v1/repuestos/por_codigos',
      { codigos },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error obteniendo repuestos por códigos:', error)
    return false
  }
}

// Búsqueda semántica (RAG) del catálogo Axioma — buscador real de materiales.
// Usa la URL absoluta del gateway (la misma del curl), no la base de apiAxioma.
// NOTA: la API key queda expuesta en el bundle del front; idealmente debería
// servirse vía variable de entorno o proxy de backend.
const AXIOMA_RAG_SEARCH_URL =
  'https://client-gateway-190008720722.us-central1.run.app/api/v1/catalog/axioma-rag/rag/search'
const AXIOMA_RAG_API_KEY = 'axioma-rag_30922800269fd119342a94304fe49124'

export const getAxiomaRagSearch = async (query) => {
  try {
    const response = await axios.get(AXIOMA_RAG_SEARCH_URL, {
      params: { q: query },
      headers: {
        'x-api-key': AXIOMA_RAG_API_KEY,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error en búsqueda RAG de catálogo Axioma:', error)
    return null
  }
}

export const getImagenArgumentacionCatalogo = async (revisionId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/revisiones/imagen_argumentacion_catalogo?revision_id=${revisionId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postImagenArgumentacionCatalogo = async (
  revisionId,
  imageFile,
) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('imagen', imageFile)

    const response = await apiAxioma.post(
      `/v1/revisiones/imagen_argumentacion_catalogo?revision_id=${revisionId}`,
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error uploading catalog update image:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const deleteImagenArgumentacionCatalogo = async (revisionId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.delete(
      `/v1/revisiones/imagen_argumentacion_catalogo?revision_id=${revisionId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// tipos

export const getTiposEmbalaje = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/componentes_proteccion/tipos_embalaje`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getTiposProteccion = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/componentes_proteccion/tipos_proteccion`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getTiposEmpaque = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/componentes_proteccion/tipos_empaque`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearEmpaque = async ({ nombreEmpaque }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/componentes_proteccion/tipos_empaque',
      { nombre: nombreEmpaque },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const getMarcasFabrica = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/marcas/marca_fabrica`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearMarcaFabrica = async ({ nombreMarcaFabrica }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/marcas/marca_fabrica',
      { nombre: nombreMarcaFabrica },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearProteccion = async ({ nombreProteccion }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/componentes_proteccion/tipos_proteccion',
      { nombre: nombreProteccion },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearEmbalaje = async ({ nombreEmbalaje }) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/componentes_proteccion/tipos_embalaje',
      { nombre: nombreEmbalaje },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}
// MODELO

export const getModelosAplicacion = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(`/v1/modelos_aplicacion`, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearModelo = async (nombreModelo) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/modelos_aplicacion',
      { nombre: nombreModelo },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// BÓVEDA DE DOCUMENTOS - CATÁLOGOS

export const getProveedores = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      '/v1/admin_catalogos/proveedores/SAP',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      // La respuesta viene como {"success": [{"nombre": "CORSAIR"}, ...]}
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener proveedores:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearProveedor = async (nombreProveedor) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/proveedores/sap',
      { nombre_proveedor: nombreProveedor },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al crear proveedor:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getCatalogosPorProveedor = async (nombreProveedor) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/admin_catalogos/catalogos?nombre_proveedor=${nombreProveedor}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      // La respuesta viene como {"success": [{"signed_url": "...", "path": "...", "gs_url": "..."}]}
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener catálogos:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearCatalogo = async (
  archivo,
  codigoProveedor,
  nombreProveedor,
  usuarioId,
  modeloAplicacionId,
  grupoCompras,
  planificador,
  paisOrigen,
) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('codigo_proveedor', codigoProveedor)
    formData.append('nombre_proveedor', nombreProveedor)
    formData.append('usuario_id', usuarioId)
    formData.append('modelo_aplicacion', modeloAplicacionId)
    formData.append('planificador', planificador)
    formData.append('pais_origen', paisOrigen)
    if (grupoCompras) {
      formData.append('grupo_compras', grupoCompras)
    }
    formData.append('archivo', archivo)

    const response = await apiAxioma.post(
      `/v1/admin_catalogos/catalogos`,
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al crear catálogo:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const deleteCatalogo = async (path) => {
  loaderService.show()
  try {
    const response = await apiAxioma.delete(`/v1/admin_catalogos/catalogos`, {
      headers: {
        Authorization: `${getToken()}`,
      },
      params: {
        path,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al eliminar catálogo:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postTraductorRepuestos = async (imagenes, observaciones) => {
  loaderService.show()
  try {
    const formData = new FormData()

    // Agregar las imágenes: image, image2, image3, image4
    imagenes.forEach((imagen, index) => {
      if (index === 0) {
        formData.append('imagen', imagen.file)
      } else {
        formData.append(`imagen${index + 1}`, imagen.file)
      }
    })

    // Agregar observaciones (puede estar vacío)
    formData.append('observaciones', observaciones || '')

    const response = await apiAxioma.post('/v1/traductor_repuestos', formData, {
      headers: {
        Authorization: `${getToken()}`,
        Origin: 'lucia.com.co',
        'Content-Type': 'multipart/form-data',
      },
    })

    if (response.status === 200 || response.status === 201) {
      console.log('Respuesta del servidor:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al traducir repuestos:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postGenerarTextoBreve = async (nombre) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/texto_breve',
      { nombre },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar texto breve:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postSubirImagenItem = async (imagen, proveedor) => {
  loaderService.show()
  try {
    const formData = new FormData()

    // Agregar la imagen y el proveedor
    formData.append('imagen', imagen.file)
    formData.append('proveedor', proveedor)

    const response = await apiAxioma.post(
      '/v1/admin_catalogos/items/subir_imagen',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      console.log('Respuesta de subir imagen:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al subir imagen:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCargarImagenItem = async (gsUrl) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/items/cargar_imagen',
      { gs_url: gsUrl },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      console.log('=== Respuesta de cargar imagen ===')
      console.log('gs_url enviado:', gsUrl)
      console.log('Respuesta completa:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al cargar imagen:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getCatalogoInfoByPath = async (path) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/catalogos/info',
      { path },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener información del catálogo:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getItemsByCatalogoId = async (catalogoId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/admin_catalogos/items?catalogo_id=${catalogoId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener items del catálogo:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postSugerirJerarquiaLote = async (items) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/sugerir-jerarquia/lote',
      items,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      console.log('Respuesta de sugerir jerarquía en lote:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al sugerir jerarquía en lote:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postSugerirGrupoArticuloLote = async (items) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/sugerir-grupo-articulo/lote',
      items,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      console.log(
        'Respuesta de sugerir grupo de artículo en lote:',
        response.data,
      )
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al sugerir grupo de artículo en lote:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postFiltrarNuevosItems = async (npfCandidatos) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/items/filtrar_nuevos',
      { npf_candidatos: npfCandidatos },
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      console.log('Respuesta de filtrar nuevos items:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al filtrar nuevos items:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCrearItems = async (items) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post('/v1/admin_catalogos/items', items, {
      headers: {
        Authorization: `${getToken()}`,
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al crear items:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postCalificacionesEstructuras = async (calificaciones) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/items/calificaciones_estructuras',
      calificaciones,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al enviar calificaciones de estructuras:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getAllItems = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/admin_catalogos/items_all', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener todos los items:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getSectores = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/sectores', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener sectores:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getFamilias = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/familias', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener familias:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getGruposArticulos = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      '/v1/admin_catalogos/grupo_articulos',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener grupos de artículos:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getGruposCompras = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/admin_catalogos/grupo_compras', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener grupos de compras:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putAprobarJerarquia = async (itemId, jerarquia) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/admin_catalogos/items/aprobar_jerarquia',
      {
        item_id: itemId,
        jerarquia,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al aprobar jerarquía:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putActualizarGrupoArticulo = async (itemId, grupoArticulo) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/admin_catalogos/items/grupo_articulo',
      {
        item_id: itemId,
        grupo_articulo: grupoArticulo,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al actualizar grupo artículo:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putActualizarTextoBreve = async (itemId, textoBreveEs) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/admin_catalogos/items/texto_breve',
      {
        item_id: itemId,
        texto_breve_es: textoBreveEs,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al actualizar texto breve:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putActualizarFob = async (itemId, fob) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/admin_catalogos/items/fob',
      {
        item_id: itemId,
        fob: parseFloat(fob) || 0.0,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al actualizar FOB:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putActualizarCantidad = async (itemId, cantidad) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/admin_catalogos/items/cantidad',
      {
        item_id: itemId,
        cantidad: parseInt(cantidad, 10) || 0,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al actualizar Cantidad:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postExportarItems = async (itemsIds) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/admin_catalogos/items/exportable',
      { items_ids: itemsIds },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      console.log('=== Respuesta de exportar items ===')
      console.log('Items exportados:', itemsIds)
      console.log('Respuesta completa:', response.data)
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al exportar items:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postImportarNPF = async (archivo) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('archivo', archivo)

    const response = await apiAxioma.post(
      '/v1/admin_catalogos/importar_items_csv/infaltables_garantia',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al importar NPF:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getImagenesPorMaterial = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      '/v1/repuestos/imagenes_por_material',
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )

    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener imágenes por material:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

// BÁSCULAS

export const getBasculas = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/basculas', {
      headers: {
        Authorization: `${getToken()}`,
        Origin: 'https://lucia.com.co',
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener básculas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getUsuariosTodos = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get('/v1/usuarios/obtener_todos', {
      headers: {
        Authorization: `${getToken()}`,
        Origin: 'https://lucia.com.co',
      },
    })
    if (response.status === 200) {
      // La respuesta puede venir como { success: [...] } o directamente como array
      if (response.data && response.data.success) {
        return response.data.success
      }
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener usuarios:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const asignarBasculaAUsuario = async (usuarioId, basculaId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/basculas/vincular',
      {
        bascula_id: basculaId,
        usuario_id: usuarioId,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al asignar báscula a usuario:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const desasignarBasculaDeUsuario = async (usuarioId, basculaId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/basculas/desvincular',
      {
        bascula_id: basculaId,
        usuario_id: usuarioId,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al desasignar báscula de usuario:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getBasculaPorUsuario = async (usuarioId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/basculas/usuario?usuario_id=${usuarioId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener báscula por usuario:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postFirmarRevision = async (gsurl) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/revisiones/firmar',
      { gsurl },
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al firmar revisión:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

/**
 * Quita el fondo de una imagen usando el backend de Photoroom (Remove Background).
 * Acepta una URL de imagen o un Blob y devuelve un Blob con la imagen procesada.
 */
export const postQuitarFondoPhotoroom = async (imageUrlOrBlob) => {
  let fileBlob
  if (typeof imageUrlOrBlob === 'string') {
    const res = await fetch(imageUrlOrBlob)
    if (!res.ok) throw new Error('No se pudo cargar la imagen')
    fileBlob = await res.blob()
  } else if (imageUrlOrBlob instanceof Blob) {
    fileBlob = imageUrlOrBlob
  } else {
    throw new Error('Se necesita una URL de imagen o un Blob')
  }

  const formData = new FormData()
  formData.append('image_file', fileBlob, 'image.jpg')

  const response = await apiAxioma.post(
    '/v1/externos/photoroom/segment',
    formData,
    {
      headers: {
        Authorization: `${getToken()}`,
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    },
  )
  return response.data
}

export const postGenerarImagenConCotas = async (imagenFile, name) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('gsurl', imagenFile)
    formData.append('nombre', 'PLATINA PORTARESORTES CLUTCH UNIVERSAL ESTRELLA')
    const response = await apiAxioma.post(
      '/v1/poner_cotas/generar_imagen',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar imagen con cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getGenerarCoordenadas = async (nombre) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/poner_cotas/generar_coordenadas?nombre=${nombre}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      // Verificar si la respuesta tiene un error
      if (response.data && response.data.success === 0 && response.data.error) {
        throw new Error(response.data.error)
      }
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar coordenadas:', error)
    // Re-lanzar el error para que pueda ser manejado en el componente
    throw error
  } finally {
    loaderService.hide()
  }
}

export const postCotas = async (revisionId, gsurl, cotas, medidas) => {
  loaderService.show()
  try {
    // Validar que las medidas sean un array válido y no esté vacío
    if (!medidas || !Array.isArray(medidas) || medidas.length === 0) {
      console.error(
        'Error: Las medidas son obligatorias y no pueden estar vacías',
      )
      loaderService.hide()
      return false
    }

    // Validar que todas las medidas tengan valores válidos
    const medidasInvalidas = medidas.filter(
      (medida) =>
        !medida.medida ||
        medida.valor === null ||
        medida.valor === undefined ||
        Number.isNaN(medida.valor) ||
        !Number.isFinite(medida.valor),
    )

    if (medidasInvalidas.length > 0) {
      console.error(
        'Error: Todas las medidas deben tener valores válidos',
        medidasInvalidas,
      )
      loaderService.hide()
      return false
    }

    const response = await apiAxioma.post(
      '/v1/revisiones/imagen_cotas',

      {
        revision_id: revisionId,
        gs_url: gsurl,
        json_coordenadas: cotas,
        json_medidas: medidas,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar imagen con cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const putCotas = async (imagenCotaId, gsurl, cotas) => {
  loaderService.show()
  try {
    const response = await apiAxioma.put(
      '/v1/revisiones/imagen_cotas',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
      {
        imagen_cotas_id: imagenCotaId,
        gs_url: gsurl,
        json_coordenadas: cotas,
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar imagen con cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getImagenCotas = async (revisionId) => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      `/v1/revisiones/imagen_cotas?revision_id=${revisionId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener imagen con cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

// Genera la imagen con la tabla de cotas (la que se usa para cotizar). El
// backend la arma a partir de las medidas que el material ya tiene guardadas
// en la plantilla, por eso solo recibe el código del material y el nombre de
// la imagen (sin ruta ni extensión).
export const postImagenTablaCotas = async (codigoMaterial, nombreImagen) => {
  loaderService.show()
  try {
    const response = await apiAxioma.post(
      '/v1/revisiones/imagen_tabla_cotas',
      {
        material: `${codigoMaterial}`,
        nombre_imagen: nombreImagen,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al generar la imagen de la tabla de cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postImagenCotasRecortada = async (imagenFile, materialId) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('imagen', imagenFile)
    formData.append('material', `${materialId}-recortada`)

    const response = await apiAxioma.post(
      '/v1/revisiones/imagen_cotas_recortada',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'multipart/form-data',
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al recortar imagen:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const deleteImagenCotas = async (imagenCotasId, gsUrl) => {
  loaderService.show()
  try {
    const response = await apiAxioma.delete('/v1/revisiones/imagen_cotas', {
      data: {
        imagen_cotas_id: imagenCotasId,
        gs_url: gsUrl,
      },
      headers: {
        Authorization: `${getToken()}`,
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 204) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al eliminar imagen con cotas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postNotificarCambioResponsable = async ({
  validadorId,
  revisionId,
  tipoCambio,
  valorAnterior,
  valorActual,
}) => {
  try {
    const response = await apiAxioma.post(
      '/v1/notificacion_cambios/responsable',
      {
        validador_id: validadorId,
        revision_id: revisionId,
        tipo_cambio: tipoCambio,
        valor_anterior: valorAnterior,
        valor_actual: valorActual,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al notificar cambio al responsable:', error)
    return false
  }
}

// revisiones - especificaciones (medidas generadas vs ilegibles)
export const getEspecificacionesLimpias = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      '/v1/revisiones/especificaciones_limpias',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener especificaciones limpias:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const getEspecificacionesDanadas = async () => {
  loaderService.show()
  try {
    const response = await apiAxioma.get(
      '/v1/revisiones/especificaciones_danadas',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al obtener especificaciones dañadas:', error)
    return false
  } finally {
    loaderService.hide()
  }
}

export const postMejorarRepuesto = async (gsurl) => {
  try {
    loaderService.show()
    const formData = new FormData()
    formData.append('gsurl', gsurl)
    const response = await apiAxioma.post(
      '/v1/repuestos/mejorar_repuesto',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error al notificar cambio al responsable:', error)
    return false
  } finally {
    loaderService.hide()
  }
}
